import React from 'react';

import ConversationItemDetails from 'eCoach/convoPrep/ConversationItemDetails';
import * as Text from 'theme/components/Text.style';

interface ConversationItem {
  description?: string;
  prep?: string[];
  reactions?: string[];
  example_language?: string[];
  title?: string;
  [key: string]: any;
}

interface ConversationItemPrintProps {
  item: ConversationItem;
  title?: string;
  printContentRef: React.RefObject<HTMLDivElement>;
}

export default function ConversationItemPrint({
  item,
  title,
  printContentRef,
}: ConversationItemPrintProps): JSX.Element {
  return (
    <div style={{ display: 'none' }}>
      <div ref={printContentRef} style={{ padding: '20px' }}>
        <Text.H2 style={{ marginBottom: '24px' }}>
          {title || item?.title}
        </Text.H2>
        <ConversationItemDetails item={item} />
      </div>
    </div>
  );
}
